<div class="container-fluid" *ngIf="checkDataExists">
    <fieldset class="border rounded-3 p-1">
        <legend class="float-none w-auto px-1 font-size-13"> {{'REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.TITLE' |
            translate}}</legend>
        <div class="row px-1">
            <div class="col-md-6 m-0-10-0" *ngFor="let dataSource of groupedReviewList; let i = index">
                <div class="mat-elevation-z8">
                    <div class="table-header">
                        <strong>{{ dataSource[0]?.levelDescription }}</strong>
                    </div>
                    <table mat-table [dataSource]="dataSource" class="mat-table custom-table table-bordered">
                        <ng-container *ngFor="let column of columns" [matColumnDef]="column.field">
                            <th mat-header-cell *matHeaderCellDef class="custom-header" [style.width]="column.colWidth">
                                {{ column.header | translate }} </th>
                            <td mat-cell *matCellDef="let element" class="custom-cell"
                                [class.right-align]="column.isRightAlign">
                                <span [style.width]="column.colWidth" appEllipsis>{{ column.isCurrency ? (element[column.field] | multilingualCurrency) : element[column.field] }}</span>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsSubAndMiscWise"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsSubAndMiscWise;"></tr>
                    </table>
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="container-fluid customizeText" *ngIf="!checkDataExists">
    {{'REVIEW_SUBCONTRACTOR_Miscellaneous_TAB.SUBCONTRACTOR_MISCELLANEOUS_DATA_NOT_FOUND' | translate}}
</div>